import { merge } from 'lodash';
import storeMixin from '@/js/store/mixins/vuex-store';

const getInitialState = () => ({ priceTags: [] });

const store = {
    namespaced: true,
    state: getInitialState(),
    getters: {
        priceTagsKeyed: state =>
            state.priceTags.reduce((acc, tag) => {
                acc[tag.id] = tag;
                return acc;
            }, {}),
    },
    mutations: {},
    actions: {},
};

export default merge(
    {},
    storeMixin({ resource: 'price-tag', getInitialState, readOnly: true }),
    store
);
